<template>
  <div class="payment-plan-container">
    <PaymentForm
      ref="commonForm"
      :id="virtualId"
      :bindData="investData"
      :editId="$route.params.id"
      :planList="basicInfoData.planList"
      :basicInfoData="basicInfoData"
      :editStatus="true"
      @setId="setId"
      @setBasicInfoData="setBasicInfoData"
    />

    <Accessory
      v-if="
        uploadPermissionNameOne != '' &&
        (projectData.projectInfoId || basicInfoData.projectInfoId) &&
        virtualId
      "
      :idname="uploadPermissionNameTwo"
      :fileMenuUrlname="uploadPermissionNameOne"
      :projectid="projectData.projectInfoId || basicInfoData.projectInfoId"
      :dynamicId="virtualId"
      :upload="true"
      :permissionList="permissionList"
      :isPermission="true"
    />

    <InfoContainer
      :infoTitle="commentConfig['infoTitle']"
      :contentConfig="commentConfig['infoContent']"
    >
      <template #commentInfo>
        <!-- 会签意见区 -->
        <CommentBlock
          ref="commentBlock"
          :id="virtualId"
          @fileChange="fileChange"
        />
      </template>
    </InfoContainer>
    <div style="width: 100%; height: 40px"></div>
    <div class="bottom-container">
      <div class="button-container">
        <el-button type="primary" @click="savePage">保存
        </el-button>
        <el-button type="primary" plain @click="startProcess" v-if="!basicInfoData.flowableId"
          >发起流程</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import * as api from "@/api/factoring/factoringScheme";
import { lendingDetail } from "@/api/factoring/factoring";
import workFlow from "@/mixins/workFlow";
import Accessory from "@/components/accessoriesother/accessoryFactor";
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import PaymentForm from "./components/form";
import util from "@/mixins/util";
export default {
  name: "PaymentPlan",
  mixins: [workFlow, util],
  data() {
    return {
      basicInfoData: {
        planList: [],
        projectInfoId:''
      },
      processKey: "process_pre_repay",
      detailFormUrl: "/factoring/preRepayment/preRepaymentDetail",
      virtualId: "",
      formData: {},
      investData: {},
      projectData: {
        projectInfoId:''
      },
    };
  },
  components: {
    PaymentForm,
    Accessory,
    InfoContainer,
    CommentBlock,
  },
  async mounted() {
    if (this.$route.params.id && this.$route.params.id != "0") {
      this.virtualId = this.$route.params.id;
      this.queryRepaymentDetail(this.$route.params.id);
    }
    this.getBasicConfigData();
  },
  methods: {
    // setId(id) {
    //   this.virtualId = id
    // },
    setBasicInfoData(data) {
      this.projectData = data;
    },
    async queryRepaymentDetail() {
      let res = await api.getDetailPlanView({ rentId: this.virtualId });
      if (res.data.code == 200) {
        let basicInfoData = res.data.data;
        basicInfoData.auditStatusStr = await this.queryDict(
          `${basicInfoData.auditStatus}`,
          "/api/blade-system/dict-biz/dictionary?code=project_build_state"
        );
        basicInfoData.leaseTotal = basicInfoData.planList.length;
        this.basicInfoData = basicInfoData;

        // 获取详情数据
        this.queryLendingInfo(res.data.data.loadId);
      } else {
        this.$message.error(res.data.message);
      }
    },

    async queryLendingInfo(id) {
      let res = await lendingDetail({ id });
      if (res.data.code == 200) {
        let initDate = `${this.basicInfoData.anticipatedValueDate}`;
        let initData = {
          conManageId: this.basicInfoData.conManageId,
          planName: this.basicInfoData.parentRentalName,
          planId: this.basicInfoData.parentRentalId,
          planDate: `${initDate.substring(0, 4)}-${initDate.substring(4,6)}-${initDate.substring(6, 8)}`,
          ...res.data.data,
        };
        this.investData = initData;
      }
    },

    // 会签意见区附件设置
    fileChange(fileList) {
      let self = this;
      if (fileList.length > 0) {
        this.attchmentList = [];
        fileList.map((item) => {
          self.attchmentList.push({
            name: item.name,
            url: item.response.data.link,
          });
        });
      }
    },

    setId(id) {
      
      this.virtualId = id;
    },

    async startProcess() {
      let formData = this.$refs.commonForm.investForm;
      let processInsId = "";
      let params = { id: this.virtualId };
      let redirectInfo = {
        url: this.detailFormUrl,
        id: this.virtualId,
      };

      let processParams = {
        detailFormUrl: JSON.stringify(redirectInfo),
        processId: this.processDefinedId,
        comment: this.$refs.commentBlock.$data.opinionContent,
        attachmentList: this.attchmentList,
      };

      processInsId = await this.startWorkFlowProcess(processParams);
      params.flowableId = processInsId;
      let res = await api.setFlowabledId(params);
      if (res.data.code == 200) {
        this.$router.push({
          path: `/factoring/preRepayment/preRepaymentDetail/${this.virtualId}`,
        });
        this.$message({
          type: "success",
          message: "发起流程成功",
        });
      }
    },

    async savePage() {
      
      let formData = this.$refs.commonForm.investForm;
      let msg = this.$route.params.id ? "修改成功" : "新增成功";
      if (
        formData.contractId != "" &&
        formData.batchId != "" &&
        formData.rentId != "" &&
        formData.planPayDate != ""
      ) {
        let params = {
          contractId: formData.contractId,
          rentId: formData.rentId,
          planPayDate: formData.planPayDate,
          id: formData.batchId,
        };
        // 保存数据
        let res = await api.generateRentPlan(params);
        if (res.data.code == 200) {
          this.virtualId = res.data.data;
          this.$router.push({
            path: `/factoring/preRepayment/preRepaymentDetail/${res.data.data}`,
          });
          this.$message({
            type: "success",
            message: msg,
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.payment-plan-container {
  /deep/ .avue-form__menu--center {
    display: none;
  }
  .bottom-container {
    width: 100%;
    height: 70px;
    position: fixed;
    // z-index: 1000;
    bottom: 0px;
    left: 0px;
    z-index: 1000;
    background-color: #fff;
    box-shadow: 0px -8px 10px rgba(0, 0, 0, 0.05);
    .button-container {
      width: 78%;
      height: 100%;
      margin: 0 auto;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>